import type {ActionSpec, ActionStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const GetContactAttributesInputSchema = z.object({});
export type GetContactAttributesInput = z.infer<typeof GetContactAttributesInputSchema>;

export const GetContactAttributesOutputSchema = z.object({
  attributes: z.array(
    z.object({
      name: z.string(),
      category: z.enum(['normal', 'transactional', 'category', 'calculated', 'global']),
      type: z.enum(['text', 'date', 'float', 'id', 'boolean', 'multiple-choice', 'user']),
    })
  ),
});
export type GetContactAttributesOutput = z.infer<typeof GetContactAttributesOutputSchema>;

export type GetContactAttributesActionStruct = ActionStruct<
  'get-contact-attributes',
  GetContactAttributesInput,
  GetContactAttributesOutput
>;
export const GetContactAttributesActionSpec: ActionSpec<GetContactAttributesActionStruct> = {
  id: 'get-contact-attributes',
  inputSchema: GetContactAttributesInputSchema,
  outputSchema: GetContactAttributesOutputSchema,
};
